export default "__VITE_ASSET__e812775a__"